export default "__VITE_ASSET__BjtX6zlQ__"